// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"771":"7d2983d388d0f511","888":"515b777e2b2f600f","963":"d35f9a64a35664f0"}[chunkId] + ".css";
};